import { AuthService } from "./../../../service/api";
import { OnInit, Component, ViewChild, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { UserInfo } from "src/app/common/interfaces/user.interface";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ConfirmModalComponent } from "src/app/common/component/confirm-modal/confirm-modal.component";

@Component({
  templateUrl: "settings.component.html",
  styleUrls: ["settings.component.scss"],
})
export class UserSettingsComponent implements OnInit {
  userInfo: UserInfo = null;
  isOwner = true;
  showDeleteModal = false;
  showDeleteWarning = false;
  errMessage = "";

  deleteModalRef: MatDialogRef<ConfirmModalComponent>;
  deleteWarningRef: MatDialogRef<any>;

  @ViewChild("deleteWarning", { static: true })
  deleteWarning: TemplateRef<any>;

  constructor(
    protected authService: AuthService,
    protected router: Router,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.getUserInfo();
  }

  getUserInfo() {
    this.authService.userInfo$.subscribe((res) => (this.userInfo = res));
  }

  deleteConfirm() {
    this.showDeleteModal = true;
    this.deleteModalRef = this.dialog.open(ConfirmModalComponent, {
      id: "deleteClientModal",
      disableClose: true,
      autoFocus: false, 
      restoreFocus: false,
      data: {
        useConfirmWord: true,
        confirmWord: "Delete",
        content: `Deleting the Developer Console account is a permanent operation which can 
                  not be revoked.\n\nYour Samsung Account will still exist, but will get un-linked from 
                  the Developer Console portal and all existing data will be erased.`,
      },
    });

    this.deleteModalRef.componentInstance.clickHandler.subscribe(() => {
      this.handleDeleteClient();
    });

    this.deleteModalRef.componentInstance.showChange.subscribe((event) => {
      this.closeConfirmDelete(event);
    });
  }

  handleDeleteClient() {
    if (this.deleteModalRef) this.deleteModalRef.close();
    this.authService.deleteAccount().subscribe(
      () => this.handleLogoutWhenDelete(),
      (err) => {
        console.error(err);
        this.errMessage = err.error.message;
        this.showDeleteWarning = true;
        this.deleteWarningRef = this.dialog.open(this.deleteWarning, {
          autoFocus: false, 
          restoreFocus: false,
          panelClass: 'warning',
          width: '580px',
          id: 'deleteWarning'
        })
      }
    );
  }

  closeConfirmDelete(event) {
    if (event) this.showDeleteModal = false;
  }

  closeDeleteWarning() {
    this.showDeleteWarning = false;
    this.deleteWarningRef.close();
  }

  private handleLogoutWhenDelete() {
    this.authService.logoutWhenDelete();
  }
}
